






























































































import { Component, Prop, Vue} from 'vue-property-decorator';
import * as dayjs from 'dayjs';
import HeatmapService from '../services/HeatmapService';
import CSVLayer from '@arcgis/core/layers/CSVLayer';


@Component
export default class LockboxDateRange extends Vue {

    public startDate = dayjs.default().subtract(7, 'day').format('YYYY-MM-DD');
    public endDate = dayjs.default().format('YYYY-MM-DD');
    public csvLayer: __esri.CSVLayer | null = null;

    // this is used directly as as CsvLayer url, not through axios request
    // public baseUrl: string = 'https://localhost:44336/lockbox/csv';
    public baseUrl: string = 'https://nsar-webapi.azurewebsites.net/lockbox/csv';

    public heatmapRenderer = {
        type: 'heatmap',
        colorStops: [
            { color: 'rgba(0, 0, 0, 0)', ratio: 0 },
            { color: '#00A100', ratio: 0.33 },
            { color: '#FFB200', ratio: 0.66 },
            { color: '#FF0000', ratio: 1 },
        ],
        maxPixelIntensity: 75,
        minPixelIntensity: 0,
    };

    get map() {
        return this.$store.state.map;
    }

    get mapView() {
        return this.$store.state.mapView;
    }

    get csvUrl() {
        return this.baseUrl + '?startDate=' + this.startDate + '&endDate=' + this.endDate;
    }

    get showChart() {
        return this.$store.state.heatmap.showChart;
    }

    get showHeatmapChart() {
        return this.$store.state.heatmap.showHeatmapChart;
    }

    get isLegendActive() {
        return this.$store.state.heatmap.showLegend;
    }

    get isChartActive() {
        return this.$store.state.heatmap.showChart;
    }

    get isCountActive() {
        return this.$store.state.heatmap.showHeatmapChart;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initHeatmap') {
            this.addCsvLayer();
            this.$store.dispatch('updateDateCount', {startDate: this.startDate, endDate: this.endDate});
        }
    });

    public mounted() {
        console.log('LockboxDateRange: mounted()');
        this.$store.dispatch('updateEndDate', this.endDate);
        this.$store.dispatch('updateStartDate', this.startDate);
    }

    public beforeDestroy() {
        console.log('LockboxDateRange: beforeDestroy()');
        this.unsubscribe();
    }

    public toggleLegend() {
        if (this.isChartActive) {
            this.toggleChart();
        }
        if (this.isCountActive) {
            this.toggleHeatmapChart();
        }
        this.$store.dispatch('toggleLegend');
    }

    public toggleChart() {
        if (this.isLegendActive) {
            this.toggleLegend();
        }
        if (this.isCountActive) {
            this.toggleHeatmapChart();
        }
        this.$store.dispatch('toggleChart');
    }

    public toggleHeatmapChart() {
        if (this.isLegendActive) {
            this.toggleLegend();
        }
        if (this.isChartActive) {
            this.toggleChart();
        }
        this.$store.dispatch('toggleHeatmapChart');
    }

    public thisWeek() {
        this.endDate = dayjs.default().format('YYYY-MM-DD');
        this.startDate = dayjs.default().subtract(7, 'day').format('YYYY-MM-DD');
        this.onDateChange(); // these don't trigger the model change
    }

    public lastWeek() {
        this.endDate = dayjs.default().subtract(7, 'day').format('YYYY-MM-DD');
        this.startDate = dayjs.default().subtract(14, 'day').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public thisMonth() {
        this.endDate = dayjs.default().format('YYYY-MM-DD');
        this.startDate = dayjs.default().subtract(1, 'month').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public lastMonth() {
        this.endDate = dayjs.default().subtract(1, 'month').format('YYYY-MM-DD');
        this.startDate = dayjs.default().subtract(2, 'month').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public thisQuarter() {
        this.endDate = dayjs.default().format('YYYY-MM-DD');
        this.startDate = dayjs.default().subtract(3, 'month').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public lastQuarter() {
        this.endDate = dayjs.default().subtract(3, 'month').format('YYYY-MM-DD');
        this.startDate = dayjs.default().subtract(6, 'month').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public thisYear() {
        this.endDate = dayjs.default().endOf('year').format('YYYY-MM-DD');
        this.startDate = dayjs.default().startOf('year').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public lastYear() {
        this.endDate = dayjs.default().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
        this.startDate = dayjs.default().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
        this.onDateChange();
    }

    public onDateChange() {
        console.log('onDateChange');

        this.$store.dispatch('updateDateCount', {startDate: this.startDate, endDate: this.endDate});

        // @ts-ignore
        this.$refs.qDateProxyEnd.hide();
        // @ts-ignore
        this.$refs.qDateProxyStart.hide();

        this.$store.dispatch('updateEndDate', this.endDate);
        this.$store.dispatch('updateStartDate', this.startDate);

        if (!this.csvLayer) {
            this.addCsvLayer();
        } else {
            this.updateCsvLayer();
        }

    }

    public addCsvLayer() {
        // @ts-ignore
        this.csvLayer = new CSVLayer({
            url: this.csvUrl,
            latitudeField: 'Lat',
            longitudeField: 'Lon',
            title: 'Lockbox Transactions',
            // renderer: pointRenderer,
            renderer: this.heatmapRenderer,
            labelsVisible: false,
            opacity: 0.7,
        });

        console.log('Adding heatmap Layer');
        this.map.layers.push(this.csvLayer);
    }

    public updateCsvLayer() {
        if (this.csvLayer) {
            console.log('Updating heatmap url');
            // HEY ESRI please make a way to refresh this layer...
            const watchHandle = this.mapView.map.allLayers.on('change', (event: any) => {
                if (event.removed.length > 0) {
                    watchHandle.remove();
                    this.addCsvLayer();
                }
            });
            this.map.remove(this.csvLayer);
        }
    }

}

